var _title, _path, _path2, _path3, _path4, _ellipse, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdeal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 92 81"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "provider-ideal"
}, "iDeal")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 6v69a6 6 0 0 0 6 6h41.28C78.48 81 92 63.56 92 40.41S78.48 0 47.28 0H6a6 6 0 0 0-6 6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#c06",
  d: "M27.62 16.93v51h22.21c20.17 0 28.92-11.38 28.92-27.47C78.75 25 70 13.09 49.83 13.09H31.47a3.85 3.85 0 0 0-3.85 3.84"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M47.28 75.51H11.39a5.78 5.78 0 0 1-5.77-5.77V11.29a5.78 5.78 0 0 1 5.77-5.77h35.89c34.05 0 39.13 21.89 39.13 34.92 0 22.61-13.92 35.07-39.13 35.07M11.39 7.45a3.84 3.84 0 0 0-3.85 3.84v58.45a3.84 3.84 0 0 0 3.85 3.84h35.89c24 0 37.21-11.76 37.21-33.14 0-28.7-23.33-33-37.21-33z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M35.44 33.56a6.3 6.3 0 0 1 2.19.37A4.9 4.9 0 0 1 39.4 35a6.1 6.1 0 0 1 1.17 1.86 7.5 7.5 0 0 1 .43 2.68 9 9 0 0 1-.33 2.46 5.9 5.9 0 0 1-1 2 5 5 0 0 1-1.71 1.29 6 6 0 0 1-2.43.48h-5.29V33.53h5.2zm-.18 9.94a3.8 3.8 0 0 0 1.14-.18 2.24 2.24 0 0 0 1-.63 3.5 3.5 0 0 0 .69-1.14 4.8 4.8 0 0 0 .27-1.71 7 7 0 0 0-.18-1.65 3.3 3.3 0 0 0-.6-1.26 2.7 2.7 0 0 0-1.08-.81 4.4 4.4 0 0 0-1.66-.27h-1.96v7.68h2.38zm16.59-9.94v2.26h-6.44v2.61h5.92v2.07h-5.92v3H52v2.25h-9.26V33.53h9.11zm9.15 0 4.57 12.19h-2.75l-.94-2.7h-4.56l-1 2.7h-2.7l4.6-12.19zm.19 7.44-1.53-4.47L58 41zM70 33.56v9.94h6v2.25h-8.71V33.56z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.58,
  cy: 39.66,
  fill: "#000",
  rx: 5.62,
  ry: 5.61
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M21.82 67.91a8.5 8.5 0 0 1-8.51-8.5v-6.63a4.27 4.27 0 0 1 4.27-4.26 4.26 4.26 0 0 1 4.27 4.26v15.13z"
})));
export { SvgIdeal as ReactComponent };